import type { RouteNode } from "./urls/types";
import { isRouteLocation, lastVisitedLocation, routes } from "./urls";

const SOURCE_PAGES: Array<[string, RouteNode[]]> = [
  [
    "recents",
    [routes.recents, routes.recents.autofix, routes.recents.autotune],
  ],
  ["favorites", [routes.favorites, routes.favorites.links]],
  ["chats", [routes.chats]],
  ["personal", [routes.personal, routes.personal.links]],
  ["links", [routes.links]],
  ["space", [routes.space]],
  ["space_links", [routes.space.links]],
  ["leaderboard", [routes.space.leaderboard]],
];

function sourcePageForUrl(url: string) {
  return (
    SOURCE_PAGES.find(([, scopes]) =>
      scopes.some((scope) => isRouteLocation(scope, url))
    )?.[0] ?? "other"
  );
}

export function currentSourcePage() {
  return sourcePageForUrl(`${location.pathname}${location.search}`);
}

// Moving around inside the workflow records its own URLs, so those entries are skipped.
export function previousSourcePage(workflowId: string) {
  const previous = lastVisitedLocation(
    (url) => !url.includes(`/workflows/${workflowId}`)
  );
  return previous === undefined ? "direct" : sourcePageForUrl(previous);
}
